import { useMemo } from "react";
import { useDashboardData } from "../context/DashboardDataContext";
import { Card } from "../components/ui/Card";
import { PageHeader } from "../components/ui/PageHeader";
import { PATTERN_LABELS } from "../dashboard/analytics";

export function FounderProfile() {
  const { submissions } = useDashboardData();

  const byEmail = useMemo(() => {
    const map = new Map();
    submissions.forEach((row) => {
      const key = row.email || "unknown";
      const prev = map.get(key) || [];
      prev.push(row);
      map.set(key, prev);
    });
    return Array.from(map.entries())
      .map(([email, rows]) => {
        const sorted = [...rows].sort(
          (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        const latest = sorted[0];
        return {
          email,
          count: rows.length,
          latest,
          delta:
            rows.length > 1
              ? latest.overallPercent -
                [...rows].sort(
                  (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
                )[0].overallPercent
              : null,
        };
      })
      .sort((a, b) => b.count - a.count)
      .slice(0, 24);
  }, [submissions]);

  return (
    <div className="page">
      <PageHeader
        eyebrow="Founders"
        title="Profile roll-up"
        description="One card per email in the filtered set — useful for coaching pipelines."
      />

      <div className="profile-grid">
        {byEmail.map((f) => (
          <Card key={f.email} title={f.email} subtitle={`${f.count} submission(s)`}>
            <dl className="dl-kv">
              <div>
                <dt>Latest primary</dt>
                <dd>{PATTERN_LABELS[f.latest.primary] || f.latest.primary || "—"}</dd>
              </div>
              <div>
                <dt>Latest score %</dt>
                <dd>{f.latest.overallPercent ?? "—"}</dd>
              </div>
              <div>
                <dt>Δ if retake</dt>
                <dd>{f.delta != null ? `${f.delta > 0 ? "+" : ""}${f.delta}` : "—"}</dd>
              </div>
            </dl>
          </Card>
        ))}
      </div>
    </div>
  );
}
